"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M22.125 19.625H21.75V17C21.75 16.3906 21.2344 15.875 20.625 15.875H19.875V8.75H17.625V15.875H15.375V8.75H13.125V15.875H10.875V8.75H8.625V15.875H6.375V8.75H4.125V15.875H3.375C2.71875 15.875 2.25 16.3906 2.25 17V19.625H1.875C1.21875 19.625 0.75 20.1406 0.75 20.75V21.5C0.75 21.7344 0.890625 21.875 1.125 21.875H22.875C23.0625 21.875 23.25 21.7344 23.25 21.5V20.75C23.25 20.1406 22.7344 19.625 22.125 19.625ZM19.5 19.625H4.5V18.125H19.5V19.625ZM22.875 4.53125L12.7031 0.265625C12.5156 0.21875 12.1875 0.125 12 0.125C11.7656 0.125 11.4375 0.21875 11.25 0.265625L1.07812 4.53125C0.890625 4.57812 0.75 4.8125 0.75 5.04688V6.3125C0.75 6.64062 0.984375 6.875 1.3125 6.875H2.25V7.4375C2.25 7.76562 2.48438 8 2.8125 8H21.1875C21.4688 8 21.75 7.76562 21.75 7.4375V6.875H22.6875C22.9688 6.875 23.25 6.64062 23.25 6.3125V5.04688C23.25 4.8125 23.0625 4.57812 22.875 4.53125ZM3 5.75L12 2.375L21 5.75H3Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;